import { useState } from "react";
import type { SowingInstruction } from "../services/sowingInstructionsApi";
import { SowingInstructionsTable } from "../components/sowingInstructions/SowingInstructionsTable";
import { RecordGrowthDialog } from "../components/sowingInstructions/RecordGrowthDialog";
import { StockEntryWorkflowTable } from "../components/stockEntryPipeline/StockEntryWorkflowTable";

const SOWING_INSTRUCTION_STATUSES = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Issued" },
  { value: 2, label: "Sown" },
  { value: 3, label: "Germinated" },
  { value: 4, label: "Growing" },
  { value: 5, label: "Ready for Dispatch" },
  { value: 6, label: "Stored" },
  { value: 7, label: "Dispatched" },
  { value: 8, label: "Overgrown" },
  { value: 9, label: "Revoked" },
  { value: 10, label: "On Hold" },
  { value: 11, label: "Ready for Growing" },
  { value: 12, label: "Draft" },
];

export const RecordGrowthPage = () => {
  const [selectedInstruction, setSelectedInstruction] =
    useState<SowingInstruction | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleUpdateStatus = (instruction: SowingInstruction) => {
    setSelectedInstruction(instruction);
    setDialogOpen(true);
  };

  const handleDialogSuccess = () => {
    setDialogOpen(false);
    setSelectedInstruction(null);
    // Mutation invalidates ["sowingInstructions"] — table refetches automatically.
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Record Growth</h1>
        <p className="text-gray-500 mt-1">
          Record growth for instructions that are ready for growing. This moves them to the Growing stage.
        </p>
      </div>

      <SowingInstructionsTable
        serverPagedStatuses={11}
        statuses={SOWING_INSTRUCTION_STATUSES}
        onUpdateStatus={handleUpdateStatus}
        updateStatusLabel="Record Growth"
        showSowingDate
      />

      {selectedInstruction && (
        <RecordGrowthDialog
          instruction={selectedInstruction}
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          onSuccess={handleDialogSuccess}
        />
      )}

      {/* Currently growing entries — already placed in a greenhouse */}
      <div className="pt-4 border-t">
        <h2 className="text-xl font-semibold tracking-tight mb-1">Currently Growing</h2>
        <p className="text-gray-500 text-sm mb-4">
          Stock entries already placed in a greenhouse. You can transfer them between greenhouses or mark them ready for dispatch.
        </p>
        <StockEntryWorkflowTable stage="mark-ready" actionAllowed />
      </div>
    </div>
  );
};
